import type { FC, MouseEventHandler } from 'react';
import { mdiUnfoldMoreVertical } from '@mdi/js';
import { Icon } from '@mdi/react';

import { resizeHandleClasses } from './classes';

interface ResizeHandleProps {
  isLeftSidePlacement: boolean;
  isRightSidePlacement: boolean;
  onMouseDown: MouseEventHandler;
}

export const ResizeHandle: FC<ResizeHandleProps> = ({ isLeftSidePlacement, isRightSidePlacement, onMouseDown }) => {
  return (
    <button className={resizeHandleClasses({ isLeftSidePlacement, isRightSidePlacement })} onMouseDown={onMouseDown}>
      <Icon className="cursor-col-resize" path={mdiUnfoldMoreVertical} size={1} />
    </button>
  );
};
